const config = {
    version: '2026.04.27-1',
    homePath: "/",
    // homePath: "http://localhost:8088/",
    proxyPath: "http://localhost:6030/",
    locale: "ru",
    margin: 1,
    headerHeight: 50,
    innerHeight: 20,
    footerHeight: 10,
    topHeight: 30,
    leftWidth: 180,
    messageTimeout: 500,
    dialogBodyPadding: 0,
    relationPageSize: 50,
    devMode: true,
    labelMode: true,
    map: {fontSize: '12px'},
    ui: 'normal raised round',
    homeCenter: [3500000, 8350000],
    homeZoom: 7,
    topos: ['osm','eeco', 'esri', 'mosaic','forestmap','admmap','biotopsmap','classesmap'],
    useApplyButton: true
};
window.IasConfig = config;
